import Locality from '../locality/Locality';
import logger from '../log';
import { IceCandidateStructure } from '../locality/interfaces';
import { addDuration } from '../common/utils/duration';
import { AgentInput, PrimingData } from './interfaces';

const log = logger.getLogger(__filename);

const transformToPrimingData = (input: AgentInput): PrimingData => {
  const { chunk, eleven, ics, probe, tenData } = input;
  const { gatherDuration } = chunk;
  const { candidates, networkData } = ics || {};
  const { agentData, detectData, ecdn10AgentAPI, monitorData, success } =
    tenData || {};
  log.trace('probe...', { probe });
  addDuration({ vals: chunk.vals, key: 'total' });
  const out: PrimingData = {
    ecdn10: { agentData, detectData, monitorData, success },
    ecdn11: eleven,
    ics: ics as IceCandidateStructure,
    locality: new Locality({
      ice: candidates,
      gatherDuration,
      probe,
      agentData,
      monitorData,
      eleven
    }),
    networkData
  };
  // Only pass the ecdn10AgentAPI back if we have a successful agent request.
  if (success) {
    out.ecdn10AgentAPI = ecdn10AgentAPI;
  }
  log.trace('transform', out);
  return out;
};
export default transformToPrimingData;
